export const formatCurrency = (
  value: number,
  compact: boolean = false,
  showSymbol: boolean = true
): string => {
  if (showSymbol) {
    return new Intl.NumberFormat('ko-KR', {
      style: 'currency',
      currency: 'KRW',
      notation: compact ? 'compact' : 'standard',
      maximumFractionDigits: 0,
    }).format(value);
  } else {
    return new Intl.NumberFormat('ko-KR', {
      style: 'decimal',
      notation: compact ? 'compact' : 'standard',
      maximumFractionDigits: 0,
    }).format(value);
  }
};

export const formatPercent = (value: number): string => {
  return new Intl.NumberFormat('ko-KR', {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value / 100);
};

export const formatNumber = (num: number): string => {
  return new Intl.NumberFormat('ko-KR').format(num);
}; 

export const formatFileSize = (size: number | null): string => {
  if (size === null) {
    return '';
  }
  
  if (size < 1024) {
    return `${size} bytes`;
  } else if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(0)} KB`;
  } else {
    return `${(size / (1024 * 1024)).toFixed(0)} MB`;
  }
};

export const formatNumberWithCommas = (num: number|string): string => {
  const hasDecimal = num.toString().includes('.');
  const [integerPart, decimalPart] = num.toString().split('.');
  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return hasDecimal ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
};


export const roundToDecimals = (value: number, decimals?: number) => {
  decimals = decimals === undefined ? 3 : decimals;
  const division = 10 ** decimals;
  return Math.round(value * division) / division;
};

export const removeSpecialCharacters = (text: string): string => {
  return text.replace(/[^a-zA-Z0-9가-힣]/g, '');
};

export const removeComma = (text: string): string => {
  return text.replace(/,/g, '');
};